import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
const FilterHeading = ({ heading, onButtonClick, isShowViewAll, }) => {
    const { t } = useTranslation();
    return (_jsx(_Fragment, { children: _jsx(Box, { sx: { padding: 1 }, children: _jsxs(Box, { display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", children: [_jsx(Typography, { variant: "subtitle2", color: "primary", children: heading }), isShowViewAll && (_jsx(Button, { variant: "text", sx: { textAlign: "left", justifyContent: "flex-start" }, onClick: onButtonClick, children: t("globalSearch.viewAll") }))] }) }) }));
};
export default FilterHeading;
